/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useCallback, useMemo, useState } from 'react';

import IconButton from 'components/uiLibrary/IconButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import DatesSelectorModal from 'components/Globals/TabHeader/DatesSelectorModal';

import { CALENDAR_VIEW_TYPES } from 'constants/calendar';
import { DATE_FORMATS } from 'constants/index';

import classes from './CalendarRangeNavigation.module.scss';

const CalendarRangeNavigation = ({
  viewType,
  startDate,
  endDate,
  onShiftLeft,
  onShiftRight,
  allowLeftShift = true,
  allowRightShift = true,
}) => {
  const [showDateSelector, setShowDateSelector] = useState(false);

  const formatDate = date => date.format(DATE_FORMATS.USER_FRIENDLY_DATE);

  const title = useMemo(() => {
    if (!startDate || !endDate) {
      return '';
    }

    if (viewType === CALENDAR_VIEW_TYPES.YEAR) {
      const startYear = startDate.year();
      const endYear = endDate.year();

      if (startYear !== endYear) {
        const startMonth = startDate.format('MMM');
        const endMonth = endDate.format('MMM');
        return `${startMonth} '${startYear.toString().substr(2)} - ${endMonth} '${endYear.toString().substr(2)}`;
      }

      return startYear;
    }

    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
  }, [viewType, startDate, endDate]);

  const handleShiftLeft = useCallback(() => {
    if (onShiftLeft) {
      onShiftLeft();
    }
  }, [onShiftLeft]);

  const handleShiftRight = useCallback(() => {
    if (onShiftRight) {
      onShiftRight();
    }
  }, [onShiftRight]);

  const handleDateSelectorOpen = useCallback(() => {
    setShowDateSelector(true);
  }, []);

  const handleDateSelectorClose = useCallback(() => {
    setShowDateSelector(false);
  }, []);

  return (
    <div className={classes.calendarRangeNavigation}>
      <div className={classes.yearNavigation}>
        <IconButton className={classes.yearNavigation__previous} onClick={handleShiftLeft} disabled={!allowLeftShift}>
          <SpriteIcon icon="chevron_left" />
        </IconButton>
        <Typography weight="medium" className={classes.yearNavigation__title} onClick={handleDateSelectorOpen}>
          {title}
        </Typography>
        <IconButton className={classes.yearNavigation__next} onClick={handleShiftRight} disabled={!allowRightShift}>
          <SpriteIcon icon="chevron_right" />
        </IconButton>
      </div>

      {showDateSelector && <DatesSelectorModal isOpen={showDateSelector} onClose={handleDateSelectorClose} />}
    </div>
  );
};

export default CalendarRangeNavigation;
